export default "__VITE_ASSET__BBzKGCr4__"